import { render, staticRenderFns } from "./PunchRecord.vue?vue&type=template&id=a53179c0&"
import script from "./PunchRecord.vue?vue&type=script&lang=js&"
export * from "./PunchRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a53179c0')) {
      api.createRecord('a53179c0', component.options)
    } else {
      api.reload('a53179c0', component.options)
    }
    module.hot.accept("./PunchRecord.vue?vue&type=template&id=a53179c0&", function () {
      api.rerender('a53179c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Punch/PunchRecord/PunchRecord.vue"
export default component.exports